import { AlignmentEnumAlignment, ImageFit, ImagePosition } from '@wix/ambassador-forms-v2-form-template/types';
export function toV2LabelMediaProperties(view) {
    const media = toV2LabelMedia(view);
    const mediaSettings = toV2LabelMediaSettings(view);
    return {
        ...media && {
            media
        },
        ...mediaSettings && {
            mediaSettings
        }
    };
}
export function toV1QuestionImageProperties(media, mediaSettings) {
    const image = media?.image;
    if (!image) {
        return {};
    }
    const { altText, ...questionImage } = image;
    return {
        questionImage,
        ...altText != null && {
            questionImageAltText: altText
        },
        ...toV1QuestionImageSettings(mediaSettings)
    };
}
function toV2LabelMedia(view) {
    if (!view.questionImage) {
        return undefined;
    }
    return {
        image: {
            ...view.questionImage,
            ...view.questionImageAltText !== undefined && {
                altText: view.questionImageAltText
            }
        }
    };
}
function toV2LabelMediaSettings(view) {
    if (!view.questionImagePlacement && !view.questionImageResize && !view.questionImageAlignment) {
        return undefined;
    }
    return {
        ...view.questionImagePlacement && {
            imagePosition: toV2LabelImagePosition(view.questionImagePlacement)
        },
        ...view.questionImageResize && {
            imageFit: toV2LabelImageFit(view.questionImageResize)
        },
        ...view.questionImageAlignment && {
            imageAlignment: toV2LabelImageAlignment(view.questionImageAlignment)
        }
    };
}
function toV1QuestionImageSettings(mediaSettings) {
    return {
        ...mediaSettings?.imagePosition && {
            questionImagePlacement: mediaSettings.imagePosition === ImagePosition.BELOW ? 'bottom' : 'top'
        },
        ...mediaSettings?.imageFit && {
            questionImageResize: mediaSettings.imageFit === ImageFit.CONTAIN ? 'contain' : 'cover'
        },
        ...mediaSettings?.imageAlignment && {
            questionImageAlignment: mediaSettings.imageAlignment === AlignmentEnumAlignment.LEFT ? 'left' : mediaSettings.imageAlignment === AlignmentEnumAlignment.RIGHT ? 'right' : 'center'
        }
    };
}
function toV2LabelImagePosition(imagePlacement) {
    return imagePlacement === 'bottom' ? ImagePosition.BELOW : ImagePosition.ABOVE;
}
function toV2LabelImageFit(imageFit) {
    return imageFit === 'contain' ? ImageFit.CONTAIN : ImageFit.COVER;
}
function toV2LabelImageAlignment(imageAlignment) {
    if (imageAlignment === 'left') {
        return AlignmentEnumAlignment.LEFT;
    }
    if (imageAlignment === 'right') {
        return AlignmentEnumAlignment.RIGHT;
    }
    return AlignmentEnumAlignment.CENTER;
}

//# sourceMappingURL=label-media-properties.js.map